import { Divider as ShadcnDivider } from "../divider";

// Direct re-export for compatibility
export const Divider = ShadcnDivider;
